import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
          {item.path && index < items.length - 1 ? (
            <Link
              to={item.path}
              className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className={index === items.length - 1 ? 'text-foreground-700' : 'text-foreground-400'}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}